import { ref } from "vue";

export const requestDeleteCustomer = ref<boolean>(false);